import { patchUpdate } from 'services/ApiCheckoutPageService';
import { reloadCart } from 'components/Cart/actions';
import { IngridAPI } from './types';
import { setPageLoadingStatus } from 'components/Pagelayout/actions';
import { LoadingStatus } from 'models/LoadingStatus';
import { debounce } from 'utils/debounce';
import { ThunkDispatch } from 'components/Shared/connect';

declare const window: {
  _sw?: (fn: (api: IngridAPI) => void) => void;
} & Window;

export const suspendWidget = () => {
  if (!window._sw) return;

  window._sw(api => api.suspend());
};

export const resumeWidget = () => {
  if (!window._sw) return;

  window._sw(api => api.resume());
};

export const subscribeUserEvents = (dispatch: ThunkDispatch) => {
  if (!window._sw) return;

  const UPDATE_DEBOUNCE_TIME = 250;
  const updateCharges = debounce(() => {
    suspendWidget();
    dispatch(setPageLoadingStatus(LoadingStatus.Fetching));
    patchUpdate({ cartChanged: true }).then(() => {
      dispatch(reloadCart());
    });
  }, UPDATE_DEBOUNCE_TIME);

  window._sw(function (api) {
    api.on('data_changed', function (_, meta) {
      if (meta.price_changed && meta.initial_load === false) {
        updateCharges();
      }
    });
  });
};
